export function Dashboard() {
    return (
        <h1>Dashboard!!</h1>
    );
}